module.exports = __webpack_public_path__ + "static/media/port-todo.1d3860e1.png";